import 'reflect-metadata';
import {JsonProperty} from "json-object-mapper";

export class SpaceAddress {
  @JsonProperty({name: "line1"})
  public line1?: string = undefined;

  @JsonProperty({name: "line2"})
  public line2?: string = undefined;

  @JsonProperty({name: "city"})
  public city?: string = undefined;

  @JsonProperty({name: "region"})
  public region?: string = undefined;

  @JsonProperty({name: "zip"})
  public zip?: string = undefined;

  @JsonProperty({name: "country"})
  public country?: string = undefined;

}

export class Space {
  @JsonProperty({name: "code"})
  public code?: string = undefined;

  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "description"})
  public description?: string = undefined;

  @JsonProperty({type: SpaceAddress, name: "address"})
  public address?: SpaceAddress = undefined;

  @JsonProperty({name: "active"})
  public active?: boolean = undefined;

  @JsonProperty({name: "enabled"})
  public enabled?: boolean = undefined;

}

export class User {
  @JsonProperty({name: "space"})
  public space?: String = undefined;

  @JsonProperty({name: "email"})
  public email?: String = undefined;

  @JsonProperty({name: "first_name"})
  public firstName?: String = undefined;

  @JsonProperty({name: "last_name"})
  public lastName?: String = undefined;

  @JsonProperty({name: "login"})
  public login?: string = undefined;

  @JsonProperty({name: "password"})
  public password?: String = undefined;

  @JsonProperty({name: "enabled"})
  public enabled?: boolean = undefined;

}
